import { forwardRef, useId, type ReactNode, type TextareaHTMLAttributes } from 'react';

import styles from './Field.module.css';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement> & {
    label: ReactNode;
    hint?: ReactNode;
    error?: string;
  }
>(function Textarea({ label, hint, error, id, className, ...rest }, ref) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  const messageId = `${fieldId}-message`;
  const message = error || hint;
  return (
    <div className={`${styles.field} ${className ?? ''}`}>
      <label htmlFor={fieldId} className={styles.label}>
        {label}
      </label>
      <span className={`${styles.control} ${error ? styles.invalid : ''}`}>
        <textarea
          {...rest}
          ref={ref}
          id={fieldId}
          aria-invalid={error ? true : undefined}
          aria-describedby={message ? messageId : undefined}
          className={styles.textarea}
        />
      </span>
      {message && (
        <span id={messageId} className={error ? styles.error : styles.hint}>
          {message}
        </span>
      )}
    </div>
  );
});
